<template>
  <div class="about">

    <van-nav-bar
        title="质保详情"
        left-arrow
        @click-left="goBack"
    >
    </van-nav-bar>

    <div style="padding: 0 16px;">

    <div style="font-size: 12px;margin-top: 24px;margin-bottom: 10px;text-align: left;padding-left: 6px;">您所查询的信息如下：</div>

    <div style="padding: 6px;">
      <div style="background-color: #ffffff;box-shadow: 6px 6px 6px 6px #ececec;padding: 24px 0;">


        <div class="cus-row" v-if="detail.name">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">车主姓名</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.name}}</span></div>
        </div>


        <div class="cus-row" v-if="detail.mobile">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">联系电话</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.mobile}}</span></div>
        </div>


        <div class="cus-row" v-if="detail.brand_card">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">车牌号码</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.brand_card}}</span></div>
        </div>

        <div class="cus-row" v-if="detail.vin">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">车架号</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.vin}}</span></div>
        </div>

        <div class="cus-row">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">品牌车型</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.car_type}}</span></div>
        </div>

        <div class="cus-row">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">交车日期</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.valid_date}}</span></div>
        </div>

        <div class="cus-row">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">施工店面</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.store}}</span></div>
        </div>

        <div class="cus-row">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">施工部位</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.part}}</span></div>
        </div>

        <div class="cus-row" v-if="detail.car_color">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">原车颜色</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.car_color}}</span></div>
        </div>

        <div class="cus-row">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">车膜系列</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.product}}</span></div>
        </div>

        <div class="cus-row">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">车膜批号</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.seri_no}}</span></div>
        </div>

        <div class="cus-row">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">质保年限</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.quality_year}}年</span></div>
        </div>


        <div class="cus-row" v-if="detail.price>0">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">价格</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.price}}元</span></div>
        </div>


        <div class="cus-row">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">状态</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.status == "1"?'已生效': '审核中'}}</span></div>
        </div>


        <div class="cus-row" v-if="detail.remark">
          <div class="cus-row-col-3 t-al-r"><span class="quality_title">修改意见</span></div>
          <div class="cus-row-col-9"><span class="quality_content">{{detail.remark}}</span></div>
        </div>


        <div class="cus-row" style="margin-top: 12px;" v-if="detail.remark">
          <van-button type="primary" size="small" @click="goModify">去修改</van-button>
        </div>
      </div>




      <div class="quality" style="margin-top: 24px;background-color: #ffffff;box-shadow: 6px 6px 6px 6px #ececec;padding: 24px 0;" v-if="detail.img_type == 0">
        <div v-html="detail.content"/>
      </div>

      <div v-else style="margin-top: 24px;">
        <img style="width: 100%;" v-for="(item, index) in imgs" :src="$common.polishingImg(item)"/>
      </div>

    </div>

    </div>

    </div>
</template>


<style scoped>
table{border-collapse: collapse;}
th, td {
  width: 25%;
  border:1px solid #f1f1f1;
  line-height: 18px;
  padding: 6px;
  text-align: left;
}

</style>

<style>

.quality img{
  width: 100%;
}

.detail-block
{
  padding:12px 14px;
  border-bottom: 1px solid #f1f1f1;
  background-color: #ffffff;
}


.service-block
{
  padding: 16px;
}

.time-text
{
  font-size: 0.4rem;
  color:#000000;
}

.price-text
{
  font-size: 0.7rem;
  color:#000000;
}

.desc-text
{
  font-size: .45rem;
  color: #222222;
  line-height: .675rem;
}

.service-item
{
  background-color: #ffffff;
  border-radius: 8px;
  padding: 16px;
  position: relative;
  min-height: 70px;
  margin-top: 12px;
}

.service-item:after{
  content: "立即办理";
  font-size: 12px;
  background-color: #da4725;
  color:#ffffff;
  line-height: 40px;
  height: 40px;
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  text-align: center;
  width: 100px;
  display: block;
  right: 0;
  top: 40px;
  position: absolute;
}

.service-title{
  font-size: 14px !important;
  line-height: 24px;
  color: #5f5ea9;
  font-weight: bold;
  text-align: left;
}

.service-price
{
  font-size: 16px !important;
  line-height: 24px;
  color: #f15422;
  font-weight: 500;
  text-align: right;
}

.service-p{
  padding-left: 16px;
  position: relative;
  font-size: 12px;
  color: #989898;
  line-height: 18px;
  text-align: left;
  margin-top: 8px;
  padding-right: 85px;
}

.service-p:before
{
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background: #5f5ea9;
  display: block;
  left: 4px;
  top: 6px;
  position: absolute;
}

</style>
<script>
import common from '../assets/js/common'
import addone from '../components/addone'
import _ from 'underscore'
import {Toast} from "vant";

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components:
      {
      },
  data: function(){
    return {
      list_combine:[],
      active:0,
      id: '',
      detail: '',
      imgs:[]
    }
  },
  methods:{

    goModify:function()
    {
      wx.miniProgram.navigateTo({
        url: '/pages/dealer/main?quality_id=' + this.$route.query.id + '&id=' + common.getAuth()
      })
    },
    initPage:function()
    {
      common.commonHttp('/index/quality',{keyword: this.$route.query.id}, 'get').then((res)=>{
        Toast.clear()
        console.log('结果返回')
        console.log(res)

        res = res.data
        this.detail = res.data[0]
        if(res.data[0].imgs)
        {
          this.imgs = JSON.parse(res.data[0].imgs)
        }else{
          this.imgs = []
        }

        // if( res.status )
        // {
        //   this.$router.push({ path: '/brand_detail', query: { keyworddsre : this.keyword }})
        // }else {
        //   common.mAlert(this, res.desc)
        // }
        // this.brandClassify = res.data.hot_brand
      })
    },
    goBack()
    {
      //返回功能
      if (window.history.length <= 1) {
        this.$router.push({ path: "invoice" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
    goDetail(item)
    {
      this.$router.push({ path: '/service_detail', query: { id: item }})
    },
    goService()
    {
      this.$router.push({ path: '/collection'})
    }
  },
  created:function()
  {
    /**
     * 如果没有token则跳到登录页哟
     */
    common.checkToken(this)

    common.setTitle('确认信息');
    this.id = common.getUrlParam('id');
  },
  mounted()
  {

    console.log('查看')
    console.log(this.id)

    this.$store.commit('setTarbarIndex',1)
    this.initPage();
  },
  onShow()
  {
  },
  computed:{
    currentListCombine:function()
    {
      var _self = this;
      var subList = _.filter(this.list_combine,function(item){

        if( _self.active == 0 )
        {
          return true;
        }


        if ( _self.active == item.status )
        {
          return true;
        }
        return false;
      })
      console.log('合并列表')
      console.log(subList)
      return subList;
    }
  }
}
</script>


<style>
.quality image{width: 100% !important;}
</style>
<style scoped>
.cus-row-col-9{text-align: left;}
.message {
  color: red;
  padding: 10px;
  text-align: center;
}

.quality_title
{
  font-size: 12px;
  color:rgba(0,0,0, .4);
  line-height: 26px;
}

.bill-panel{background: #FFFFFF;
  box-shadow: 0 2px 6px 0 #E7E9F0;
  border-radius: 5px;padding: 16px;}

.quality_content
{
  font-size: 12px;
  line-height: 26px;
  color:rgba(0,0,0, .8);
  padding-left: 14px;
  box-sizing: border-box;
  text-align: left;
}

.quality-card
{
  padding: 8px 12px;
  border-radius: 8px;
  background-image: linear-gradient(90deg,#000000,#222222);
}
</style>
